import { type CameraKitOrganization, OrganizationUserRole } from "../../../gql-generated/types";

export const EmptyOrganization = Object.freeze<CameraKitOrganization>({
    id: null,
    name: "",
    role: OrganizationUserRole.Unset,
    apps: null,
    appsManagementEnabled: true,
    permissions: {
        readGroups: false,
        updateGroups: false,
        readLenses: false,
        updateLenses: false,
        scheduleLenses: false,
        readLensSources: false,
        updateLensSources: false,
        readLensAnalytics: false,
    },
    platformType: {
        web: true,
        mobile: true,
    },
    orgAuthorizedOperations: [],
    __typename: "CameraKitOrganization",
    accountIds: [],
});
